var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a-select',{attrs:{"mode":"tags","dropdownClassName":"hidden-dropdown","placeholder":"用户 ID，以回车间隔","value":_vm.value},on:{"change":_vm.onChange}}),_c('div',{staticClass:"total"},[_vm._v("合计："+_vm._s(_vm.value.length))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }